<div
  class="flex flex-col scrollbar"
  [class]="embedded() ? 'flex-1 min-h-0' : 'h-[calc(100vh-2rem)]'"
>
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <form
      #formContainer
      class="flex flex-1 flex-col p-4 text-caption gap-2"
      [class]="
        embedded()
          ? 'pb-[20rem]'
          : type() === EntryType.AbEntry
            ? 'pb-[20rem] h-sm:pb-0'
            : 'pb-[24rem] h-sm:pb-0'
      "
      [formGroup]="form.group"
    >
      <kendo-formfield>
        <kendo-label [for]="richText" [text]="'outlook.note.note' | translate"
          >*
        </kendo-label>
        <kendo-textarea
          #richText
          id="outlook-note-ui-addNote-richText"
          [rows]="6"
          resizable="vertical"
          formControlName="richText"
          required
        ></kendo-textarea>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield class="flex">
        <input
          class="order-first"
          kendoCheckBox
          type="checkbox"
          formControlName="important"
          #important
        />
        <label
          [for]="important"
          class="ml-1 text-sm order-last k-checkbox-label"
        >
          <span
            class="ml-1 mr-1 fa-icons icon-solid icon-16 icon-exclamation"
          ></span>
          {{ 'outlook.note.important' | translate }}
        </label>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          [for]="dateTime"
          [text]="'outlook.note.datetime' | translate"
          >*
        </kendo-label>
        <kendo-datetimepicker
          #dateTime
          [format]="outlookStore.fullDateTimeFormat()"
          formControlName="dateTime"
          required
          calendarType="classic"
        >
        </kendo-datetimepicker>
        <kendo-formerror>{{
          'outlook.forms.requiredField' | translate
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [for]="creator" [text]="'outlook.note.creator' | translate"
          >*
        </kendo-label>

        <kendo-dropdownlist
          [data]="configuration?.users"
          textField="name"
          valueField="id"
          fillMode="solid"
          [valuePrimitive]="true"
          formControlName="creator"
          #creator
          required
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      @if (type() === EntryType.AbEntry) {
        <kendo-formfield>
          <kendo-label
            [text]="'outlook.note.category' | translate"
          ></kendo-label>
          <kendo-dropdownlist
            [data]="configuration?.options?.categories"
            textField="name"
            valueField="id"
            fillMode="solid"
            formControlName="category"
            [valuePrimitive]="true"
          >
          </kendo-dropdownlist>
        </kendo-formfield>
      }
    </form>
  }

  <div
    class="bg-neutral-5 z-40 mt-auto flex justify-end gap-2 p-2 sticky bottom-0 h-sm:bottom-0"
  >
    <button
      kendoButton
      id="outlook-note-ui-addNote-cancel"
      rounded="large"
      class="uppercase"
      themeColor="primary"
      fillMode="flat"
      (click)="cancel()"
      [disabled]="loading"
    >
      {{ 'outlook.buttons.cancel' | translate }}
    </button>
    <button
      kendoButton
      id="outlook-note-ui-addNote-save"
      class="uppercase"
      themeColor="primary"
      [disabled]="!canSave || loading"
      (click)="save()"
    >
      {{ 'outlook.buttons.save' | translate }}
    </button>
  </div>
</div>

<maximizer-outlook-notification
  #notification
  icon="circle-exclamation"
  [closable]="true"
  entryId="note"
>
</maximizer-outlook-notification>
